// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gv-3";
export var downloadButton = "_gv-4";
export var fileContainer = "_gv-9 _gv-7";
export var fileContainerBase = "_gv-7";
export var fileContainerBaseSm = "_gv-a _gv-7";
export var fileContainerFixedHeight = "_gv-8 _gv-7";
export var fileContainerFixedHeightSm = "_gv-c _gv-a _gv-7";
export var fileContainerSm = "_gv-b _gv-a _gv-7";
export var fileInfo = "_gv-5";
export var fileInfoWidthRestricted = "_gv-6";
export var fileType = "_gv-1";
export var fileTypeName = "_gv-2";
export var fileTypeSm = "_gv-d _gv-1";
export var image = "_gv-0";
export var link = "_gv-f";
export var overflowEllipsis = "_gv-e";